// action types
const ADD_ADDON_ITEMS = 'app-name/addOnItems/ADD_ADDON_ITEMS'

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case ADD_ADDON_ITEMS:
      return { ...state, ...payload }
    default:
      return state
  }
}

// action creators
export const addAddonItems = payload => ({
  type: ADD_ADDON_ITEMS,
  payload,
})
